import { render, staticRenderFns } from "./assignment-breakdown-table.vue?vue&type=template&id=51538216&scoped=true"
import script from "./assignment-breakdown-table.vue?vue&type=script&lang=js"
export * from "./assignment-breakdown-table.vue?vue&type=script&lang=js"
import style0 from "./assignment-breakdown-table.vue?vue&type=style&index=0&id=51538216&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51538216",
  null
  
)

export default component.exports